export const ERROR_CODE_MAP = {
  401: "로그인이 필요합니다.",
  500: "서버에 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
  1000: "이미 가입된 아이디입니다. 다른 아이디를 사용해주세요.",
  1001: "유효하지 않은 요청입니다. 관리자에게 문의해주세요.",
  1002: "로그인에 실패했습니다.",
  1003: "로그인이 만료되었습니다. 다시 로그인해주세요.",
  1004: "현재 비밀번호가 틀렸습니다. 다시 입력해주세요.",
  1005: "일치하는 계정이 존재하지 않습니다. \n휴대폰 번호가 변경되었을 경우, 관리자에게 문의해주세요.",
  2001: "다른 유저가 해당 키오스크를 사용중입니다. 잠시 후 다시 시도해주세요.",
  2002: "유효하지 않은 QR코드입니다. QR코드를 다시 스캔해주세요.",
  3000: "인증 횟수를 초과했습니다. 한시간 후 다시 시도해주세요.",
  4000: "인증번호 발송에 실패했습니다. 관리자에게 문의해주세요.",
  4001: "발신번호가 차단되었습니다. 차단 목록에서 해제 후 다시 시도해주세요.",
  4002: "유효하지 않은 휴대폰 번호입니다. 휴대폰 번호를 확인해주세요.",
  4003: "유효하지 않은 인증번호입니다. 인증번호를 다시 확인해주세요.",
  4004: "이미 가입된 휴대폰 번호입니다.",
  4005: "인증 시간이 만료되었습니다. 휴대폰 인증을 다시 시도해주세요.",
  5000: "알림 설정에 실패했습니다. 관리자에게 문의해주세요.",
};
